module.exports = __webpack_public_path__ + "img/o-faia.a634bb96.jpg";